export default {"src":"/_next/static/media/users.e9181925.svg","height":513,"width":513};